import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import * as ProdutoHttp from '../../../../services/api/https/registration/produto.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  PRODUTOS: 'Carregando Produtos',
  RECALL: 'Carregando informações do produto',
}

const INITIAL_STATE = {
  selectedEstoque: null,
  selectedEmpresa: null,
  selectedProduto: null,
  empresas: getEmpresas(),
  estoques: [],
  recebimento: [],
  posicoes: [],
  expedicao: [],
  periodo: getPeriodoMesAtual(),
  globalFilterRecebimento: '',
  globalFilterExpedicao: '',
  globalFilterEstoque: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useRelatorioInventarioPosicao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      getRelatorioRecallProduto(selectedTp, estoqueId, produtoId, pInicial, pFinal) {
        EstoqueHttp.getRelatorioRecallProduto(selectedTp, estoqueId, produtoId, pInicial, pFinal)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              recebimento: res.recebimento,
              expedicao: res.expedicao,
              posicoes: res.estoque,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutos(selectedEmpresa) {
        ProdutoHttp.getProdutos(selectedEmpresa.id)
          .then(res => {
            const produtos = res.produtos.map(p => ({
              label: p.name,
              name: `${p.product_code} - ${p.name}`,
              id: p.id,
              dias_para_vencimento: p.dias_para_vencimento,
            }))
            setState(prevState => ({
              ...prevState,
              produtos: produtos,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Events
      onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          EstoqueHttp.getEstoques(selectedTp)
            .then(res =>
              setState(prevState => ({
                ...prevState,
                estoques: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          if (name === 'selectedEmpresa') {
            prevState.loadingMessage = LOAD_MESSAGE.PRODUTOS
          }
          return { ...prevState }
        })
      },

      onSearchRelatorioPosicoes(pInicial, pFinal, selectedEstoque, selectedProduto) {
        setState(prevState => {
          if (!selectedEstoque) prevState.errorMessage = 'Selecione um estoque.'
          else if (!selectedProduto) prevState.errorMessage = 'Selecione um produto.'
          else {
            prevState.periodo = { pInicial, pFinal }
            prevState.loadingMessage = LOAD_MESSAGE.RECALL
          }
          return { ...prevState }
        })
      },

      onClickGerarExcel(recebimento, expedicao, estoque, selectedProduto) {
        const colunas = [
          ['Tipo', 'Lote', 'Validade', 'Quantidade', 'Data Movimentação', 'Identificador/Cliente'],
        ]

        recebimento.forEach(r => {
          colunas.push([
            'Recebimento',
            r.lote,
            r.validade,
            r.quantidade,
            r.created_at,
            r.identifier,
          ])
        })

        expedicao.forEach(r => {
          colunas.push([
            'Expedição',
            r.lote,
            r.validade,
            r.quantidade,
            r.created_at,
            `${r.cnpj} - ${r.client}`,
          ])
        })

        estoque.forEach(r => {
          colunas.push(['Estoque', r.lote, r.validade, r.quantidade])
        })

        gerarArquivoExcel('Recall', colunas, `recall_${selectedProduto.name}.xlsx`)
      },
    }
  }, [])

  return { state, localDispatch }
}
